import React, { useState, useEffect } from "react";
import Api from "../../components/api/Api";
import { Col, Container, Row, Button } from "react-bootstrap";
import Notification, { showToast } from "../../../components/common/notification/Notification";
import { useNavigate, useParams, Link } from "react-router-dom";
import Spinner from "../../../components/common/spinner/Spinner";
import SingleDetailHeader from "../../components/singleDetail/SingleDetailHeader";
import BreadCrumb from "../../components/breadcrumb/BreadCrumb";
import { FaEdit } from "react-icons/fa";

const ViewAssociatePartner = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [initialData, setInitialData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const getPartnerApi = Api({
    url: `admin/associate/partner/${id}`,
  });

  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        if (id) {
          const partnerResponse = await getPartnerApi.fetchDataBySingleId();
          if (partnerResponse && partnerResponse.data && partnerResponse.data.statusType === "SUCCESS") {
            setInitialData(partnerResponse.data.associatedPartner);
          } else {
            showToast("Failed to fetch partner details", { type: "error" });
            navigate("/associate-partners");
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchInitialData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const breadcrumbItems = [
    { label: "", link: "/admin", icon: "fa-solid fa-house" },
    { label: "Partner Network", link: "/partners" },
    { label: "Associate Partners", link: "/associate-partners" },
    { label: "View Associate Partner", link: "", active: true },
  ];

  if (isLoading || !initialData) {
    return (
      <Container fluid style={{ marginTop: "2rem", display: "flex", justifyContent: "center" }}>
        <Spinner loading={true} />
      </Container>
    );
  }

  return (
    <>
      <Notification />
      <Container fluid style={{ marginTop: "2rem", padding: "0rem 4rem" }}>
        <BreadCrumb items={breadcrumbItems} />
        <Row>
          <Col lg={12} md={12} sm={12}>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <SingleDetailHeader
                header="View Associate Partner"
                description={`View details for associate partner ID: ${id}`}
              />
              <Link to={`/associate-partners/edit/${id}`} className="btn btn-primary d-flex align-items-center">
                <FaEdit className="me-2" /> Edit Profile
              </Link>
            </div>
            
            <div className="card p-4 shadow-sm border-0 mb-5" style={{ fontFamily: "'Inter', sans-serif" }}>
              <Row className="mb-4">
                <Col md={6}>
                  <h6 className="text-muted mb-1">Name</h6>
                  <p className="fs-5">{initialData.name || "N/A"}</p>
                </Col>
                <Col md={6}>
                  <h6 className="text-muted mb-1">Category</h6>
                  <p className="fs-5">{initialData.category?.name || "N/A"}</p>
                </Col>
              </Row>
              
              <Row className="mb-4">
                <Col md={6}>
                  <h6 className="text-muted mb-1">Phone Number</h6>
                  <p className="fs-5">{initialData.phone_number || "N/A"}</p>
                </Col>
                <Col md={6}>
                  <h6 className="text-muted mb-1">Email Address</h6>
                  <p className="fs-5">{initialData.email_address || "N/A"}</p>
                </Col>
              </Row>

              <Row className="mb-4">
                <Col md={6}>
                  <h6 className="text-muted mb-1">City</h6>
                  <p className="fs-5">{initialData.city || "N/A"}</p>
                </Col>
                <Col md={6}>
                  <h6 className="text-muted mb-1">State</h6>
                  <p className="fs-5">{initialData.state || "N/A"}</p>
                </Col>
              </Row>

              <Row>
                <Col md={12}>
                  <h6 className="text-muted mb-1">Website</h6>
                  <p className="fs-5">
                    {initialData.website ? (
                      <a href={initialData.website} target="_blank" rel="noopener noreferrer">
                        {initialData.website}
                      </a>
                    ) : (
                      "N/A"
                    )}
                  </p>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ViewAssociatePartner;
